// extracted by mini-css-extract-plugin
export default {"miTable":"MortgageInsAccruals_miTable__EvO54","radioLabel":"MortgageInsAccruals_radioLabel__J4VOX"};